export default __webpack_public_path__ + "1801619629cefcd339fc77ea9fe93548.svg";